/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-13 09:21:54
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/member/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/member/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/member/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/member/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/member/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/member/status",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/member/sort",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/member/select",
      method: "get",
      params: query
    });
  },
  // 获取用户绑定资源
  memberResource(query) {
    return request({
      url: "/member/resource",
      method: "get",
      params: query
    });
  },
  // 获取房屋的家庭成员
  familyMember(query) {
    return request({
      url: "/member/familyMember",
      method: "get",
      params: query
    });
  },
  // 获取车位/车库下绑定车辆
  getCar(query) {
    return request({
      url: "/member/car",
      method: "get",
      params: query
    });
  },
  huoyue(query) {
    return request({
      url: "/member/huoyue",
      method: "get",
      params: query
    });
  },
  // 加减积分
  jiaJianJiFen(data) {
    return request({
      url: "/member/jiaJianJiFen",
      method: "post",
      data
    });
  },
  jifenList(query) {
    return request({
      url: "/member/jifenList",
      method: "get",
      params: query
    });
  },
  removeFamilyMember(data){
    return request({
      url: "/member/removeFamilyMember",
      method: "post",
      data
    });
  },
  removeCar(data){
    return request({
      url: "/member/removeCar",
      method: "post",
      data
    });
  },
  cancelChildBind(data){
    return request({
      url: "/member/cancelChildBind",
      method: "post",
      data
    });
  },
  cancelBindFw(data){
    return request({
      url: "/member/cancelBindFw",
      method: "post",
      data
    });
  },

};
export default index;
